import '@fontsource/inter';
import './styles/globals.css';
export const Styles = () => <></>;
